import Head from 'next/head';
import RegisterLayout from '@/modules/RegisterLayout';
import RegisterForm from '@/modules/RegisterLayout/components/RegisterForm';
import withAuth from "@/hoc's/withAuth";
import { useEffect } from 'react';
const Register = () => {
  useEffect(() => {
    // user is logged in and on register page
    localStorage.removeItem('redirectTo');
  }, []);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="register.tsx">
        <title>
          PW Institute of Innovation - 4 year fully residential programme in Computer Science and AI
        </title>
        <meta name="description" content="PW Institute of Innovation offering a 4 year fully residential programme in Computer Science and AI. In parallel students also has an opportunity to get Bachelor's degree in Data Science & AI from a top IIT hosted on the Coursera platform.The degree qualifies the students, opportunities for further education in India  & abroad as well as eligibility for competitive examinations. Learn from the Industry's experts with personalized interactions and placement assurance in top companies great packages after this program." data-sentry-element="meta" data-sentry-source-file="register.tsx" />
      </Head>
      <RegisterLayout data-sentry-element="RegisterLayout" data-sentry-source-file="register.tsx">
        <RegisterForm data-sentry-element="RegisterForm" data-sentry-source-file="register.tsx" />
      </RegisterLayout>
    </>;
};
export default withAuth(Register);